import { atomWithStorage } from 'jotai/utils'

// getOnInit reads the persisted value synchronously so the defaulting effect
// in useInvestments never sees a transient null and overwrites the stored choice.
export const investment = atomWithStorage<null | number>('investment', null, undefined, {
  getOnInit: true
})
